import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { routerShape, withRouter } from 'react-router';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { searchEventComposer } from '@bibliocommons/analytics-event-composers';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import injectLibrary from '../../containers/hocs/injectLibrary';
import updateSearchQuery from '../../helpers/search/updateSearchQuery';

import './BroadenSearchLink.scss';

class BroadenSearchLink extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleBroadenClick');
  }

  getSearchURL(query) {
    const { location } = this.props.router;

    const newQuery = updateSearchQuery({
      currentQuery: location.query,
      pagination_page: undefined,
      lastSearchScope: location.query.searchScope,
      ...query
    });

    return { ...location, query: newQuery };
  }

  handleBroadenClick(e) {
    const { isBroadened, query, searchType, broadenedSearchType, router } = this.props;
    const lastSearchScope = router.location.query.lastSearchScope;

    e.preventDefault();

    if (searchType !== 'keyword') {
      const href = this.getSearchURL({
        searchType: 'keyword',
        searchScope: isBroadened && lastSearchScope
      });
      return this.props.router.push(href);
    }

    if (broadenedSearchType && !isBroadened) {
      const newScope = this.getBroadenedScope();
      sendAnalyticsEvents(searchEventComposer.composeBroadenSearchEvent({
        query,
        searchType: broadenedSearchType
      }));

      const href = this.getSearchURL({ searchType: broadenedSearchType, searchScope: newScope });
      return this.props.router.push(href);
    }

    return null;
  }

  getBroadenedScope() {
    const scopes = this.props.scopes;
    return scopes && scopes.first() && scopes.first().get('scopeId');
  }

  render() {
    const { isBroadened, broadenedSearchType, searchType, query } = this.props;

    const label = searchType !== 'keyword' ? 'form_label_expand_to_keyword' : 'empty_broaden_your_search';

    const validSearchType = !['keyword', 'bl'].includes(searchType);
    const canBroaden = broadenedSearchType && !isBroadened;
    if (validSearchType || isBroadened || canBroaden) {
      return (
        <FormattedMessage id={label} values={{ query }}>
          {(message) =>
            <a
              href="#broaden-search"
              onClick={this.handleBroadenClick}
              className="cp-broaden-search-link">
              {message}
            </a>
          }
        </FormattedMessage>
      );
    }

    return null;
  }
}

BroadenSearchLink.displayName = 'BroadenSearchLink';

BroadenSearchLink.propTypes = {
  broadenedSearchType:  PropTypes.string,
  isBroadened:          PropTypes.bool,
  router: routerShape,
  query: PropTypes.string,
  searchType: PropTypes.string,
  scopes: ImmutablePropTypes.list
};

export default withRouter(
  injectLibrary(({ site }) => ({
    scopes: site.get('scopes')
  }))(BroadenSearchLink)
);



// WEBPACK FOOTER //
// ./app/components/search/BroadenSearchLink.jsx